import { orderedDimensions, orderedImpacts } from '@upright/common/model/types';
import { ImpactBarsLayout } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/impact-bars-layout';
import { Bounds, Side } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';

export interface VerticalCoordinates {
  y1: number;
  y2: number;
}

export function haveVerticalOverlap(a: VerticalCoordinates, b: VerticalCoordinates) {
  // normalize y coordinates such that y2 is always larger
  const ay1 = Math.min(a.y1, a.y2);
  const ay2 = Math.max(a.y1, a.y2);
  const by1 = Math.min(b.y1, b.y2);
  const by2 = Math.max(b.y1, b.y2);

  return (by2 >= ay1 && ay1 > by1) || (ay2 >= by1 && by1 > ay1);
}

// export function getBoundsWithVerticalIntersect(bounds: Bounds[], y1: number, y2: number) {
//   return bounds.filter(b => haveVerticalOverlap({ y1: b.y1, y2: b.y2 }, { y1, y2 }));
// }

export function getBoundsWithVerticalIntersect(bounds: Bounds[], coordinates: VerticalCoordinates[]) {
  return bounds.filter(b => {
    for (const c of coordinates) {
      if (haveVerticalOverlap({ y1: b.y1, y2: b.y2 }, { y1: c.y1, y2: c.y2 })) {
        return true;
      }
    }
    return false;
  });
}

export function getAllBarBounds(layout: ImpactBarsLayout, side: Side) {
  const impactBars = orderedImpacts.map(code => {
    return layout.impactBarAndLabelArea(side, code);
  });
  const dimensionLayout = layout.dimensionLayout;
  const dimensionBars = dimensionLayout
    ? orderedDimensions.map(dim => {
        return dimensionLayout.dimensionBarAndLabelArea(side, dim);
      })
    : [];
  return [...impactBars, ...dimensionBars];
}

export interface VerticalCoordinates {
  y1: number;
  y2: number;
}
